<template>
    <!-- Define the component structure based on the type prop -->
    <div
        class="flex items-center gap-1 px-3 py-0.5 bg-gray-100 rounded-full border border-gray-400 w-min"
        v-if="type === 'PAYMENT'"
    >
        <LucideIcon name="CreditCard" :size="11" :stroke-width="1.8" color="#1f2937" />
        <p class="text-xs font-medium text-nowrap">Payment-linked</p>
    </div>
    <div
        class="flex items-center gap-1 px-3 py-0.5 bg-gray-100 rounded-full border border-gray-400 w-min"
        v-if="type === 'GIFTCARD'"
    >
        <LucideIcon name="Gift" :size="11" :stroke-width="1.8" color="#1f2937" />
        <p class="text-xs font-medium text-nowrap">Gift card</p>
    </div>
    <div
        class="flex items-center gap-1 px-3 py-0.5 bg-gray-100 rounded-full border border-gray-400 w-min"
        v-if="type === 'ONLINE'"
    >
        <LucideIcon name="Link" :size="11" :stroke-width="1.8" color="#1f2937" />
        <p class="text-xs font-medium text-nowrap">Affiliate link</p>
    </div>
    <div
        class="flex items-center gap-1 px-3 py-0.5 bg-gray-100 rounded-full border border-gray-400 w-min"
        v-if="type === 'CLICK_TO_ACTIVATE'"
    >
        <LucideIcon name="Cursor" :size="11" :stroke-width="1.8" color="#1f2937" />
        <p class="text-xs font-medium text-nowrap">Click to activate </p>
    </div>
</template>

<script>
import LucideIcon from "@/components/LucideIcon.vue";

export default {
    name: "offer-type-pill",
    components: {
        LucideIcon
    },
    props: {
        text: {
            type: String
        },
        type: {
            type: String
        },
        currency: {
            type: String
        }
    }
}
</script>

<style scoped>
/* Scoped CSS styles to apply styles only to this component */
</style>
